import { render, staticRenderFns } from "./WeeklyHighscoreComponent.vue?vue&type=template&id=a8dca9f2&"
import script from "./WeeklyHighscoreComponent.vue?vue&type=script&lang=ts&"
export * from "./WeeklyHighscoreComponent.vue?vue&type=script&lang=ts&"
import style0 from "./WeeklyHighscoreComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports